import {
  GenericUploadFileFormat,
  IGenericUploadParseResult,
} from "@ryde/shared";

import { genericUploadExcelFile } from "./generic-upload-excel.helpers";
import { getGenericUploadFileFormat } from "./generic-upload-file-format.helpers";
import { genericUploadCsvFile } from "./generic-upload.helpers";

/**
 * Parses an uploaded file into the backend-ready row shape, picking the parser
 * by detected format. Adding a new format means registering its extension in
 * generic-upload-file-format.helpers and wiring its parser into this switch.
 */
export const genericUploadParseFile = ({
  file,
}: {
  file: File;
}): Promise<IGenericUploadParseResult> => {
  const format = getGenericUploadFileFormat(file);

  switch (format) {
    case GenericUploadFileFormat.Csv:
      return genericUploadCsvFile({ file });
    case GenericUploadFileFormat.Excel:
      return genericUploadExcelFile({ file });
    default:
      return Promise.reject(
        new Error(`Unsupported upload file format: ${file.name}`),
      );
  }
};
